export default __webpack_public_path__ + "static/media/logo-bookmark-footer.5f5c0b75.svg";